import React, { Component } from "react";
import { Browser } from "core/utils";
import { STORAGE_KEYS } from "core/utils/constants";

const secured = WrappedComponent => {
    return class extends Component {
        isLoggedIn = () => {
            const sessionId = Browser.getSavedInfo(STORAGE_KEYS.SESSION_ID);
            return sessionId;
        };
        isChallengingOtp = () => {
            const preSessionId = Browser.getSavedInfo(STORAGE_KEYS.PRESESSION_ID);
            return preSessionId;
        };

        UNSAFE_componentWillMount() {
            if (!this.isLoggedIn()) {
                if (this.isChallengingOtp()) {
                    this.props.history.push("/otp", { from: this.props.location?.pathname });
                } else {
                    this.props.history.push("/login", { from: this.props.location?.pathname });
                }
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
};

export default secured;
